import { useRef, useEffect } from 'react';
import { motion, useAnimation, useInView } from 'framer-motion';
import './SellHowWorks.css';
import { WORKS_STEPS } from '../../../assets/utils/constants';

const listItemsVariants = {
  hidden: { opacity: 0, y: -20 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.6,
      delay: i * 0.4,
      ease: 'easeInOut',
      type: 'spring',
      bounce: 0.4,
    },
  }),
};

function SellHowWorks() {
  const itemsRef = useRef(null);
  const itemsControls = useAnimation();
  const itemsInView = useInView(itemsRef, { once: true, amount: 0.5 });

  useEffect(() => {
    itemsInView
      ? itemsControls.start('visible')
      : itemsControls.start('hidden');
  }, [itemsInView, itemsControls]);

  return (
    <div className="sell-how-works" ref={itemsRef}>
      <p className="sell-how-works__title">Как это работает</p>
      <ul className="sell-how-works__steps">
        {WORKS_STEPS.map((item, i) => (
          <motion.li
            key={item.text}
            className="sell-how-works__step"
            variants={listItemsVariants}
            initial="hidden"
            animate={itemsControls}
            custom={i}
          >
            {item.icon}
            <p className="sell-how-works__step-text">{item.text}</p>
            <p className="sell-how-works__step-number">{i + 1}</p>
          </motion.li>
        ))}
      </ul>
    </div>
  );
}

export default SellHowWorks;
